import { render } from "./AutoRefreshToken.vue?vue&type=template&id=af424d98"
import script from "./AutoRefreshToken.vue?vue&type=script&lang=js"
export * from "./AutoRefreshToken.vue?vue&type=script&lang=js"
script.render = render

export default script